import { combineReducers } from 'redux';

const defaultdownloadParams = {
    datafetched :'waiting'
  }

function params(state = defaultdownloadParams, action) {
    if (action.type === 'FETCH_DOWNLOAD_DATA') { 
        return {...state, 
            datafetched: 'pending',
        }
    } 
    if (action.type === 'FETCHED_DOWNLOAD_DATA') { 
        return {...state, 
            datafetched: 'success',
        }
    }
    if (action.type === 'FETCH_DOWNLOAD_DATA_WC_WI') { 
        return {...state, 
            datafetched: 'pending',
        }
    } 
    if (action.type === 'FETCHED_DOWNLOAD_DATA_WC_WI') { 
        return {...state, 
            datafetched: 'success',
        }
    }    
    if (action.type === 'RESET_DATA') { 
        return defaultdownloadParams
      } else {
        return state
    }
}

const dataDownload = combineReducers({
    params
});

export default dataDownload;